<script lang="ts">
  import { mloc } from "module/utils";
  import { ModuleSetting } from "module/store/ModuleSettings";

  import FormCheckbox from "./forms/FormCheckbox.svelte";
  import FormSelect from "./forms/FormSelect.svelte";
  import SettingsGroup from "./SettingsGroup.svelte";

  let { active = false } = $props();
</script>

<div class="gmtab standard-form" class:hidden={!active} role="tabpanel">
  <p class="notes">
    {mloc("SettingsGlobalSettingDescription")}
  </p>
  <SettingsGroup title="General Settings">
    <div class="options">
      <FormCheckbox
        label={mloc("SettingsGmOnly")}
        setting={ModuleSetting.GM_ONLY}
        notes={mloc("SettingsGmOnlyHint")}
      />
      <FormCheckbox
        label={mloc("SettingsFiltersSheetsEnabled")}
        setting={ModuleSetting.FILTERS_SHEETS_ENABLED}
        notes={mloc("SettingsFiltersSheetsEnabledHint")}
      />
      <FormSelect
        label={mloc("SettingsAutomaticIndexing")}
        setting={ModuleSetting.AUTOMATIC_INDEXING}
        notes={mloc("SettingsAutomaticIndexingHint")}
      />
      <FormCheckbox
        label={mloc("SettingsSearchButton")}
        setting={ModuleSetting.SEARCH_BUTTON}
        notes={mloc("SettingsSearchButtonHint")}
      />
      <FormCheckbox
        label={mloc("SettingsEmbeddedIndexing")}
        setting={ModuleSetting.EMBEDDED_INDEXING}
        notes={mloc("SettingsEmbeddedIndexingHint")}
      />
      <FormCheckbox
        label={mloc("SettingsTocIndexing")}
        setting={ModuleSetting.TOC_INDEXING}
        notes={mloc("SettingsTocIndexingHint")}
      />
    </div>
  </SettingsGroup>
</div>

<style>
  .gmtab {
    overflow: auto;
    height: 100%;
    padding: 0.6em;
  }

  .hidden {
    display: none;
  }

  .gmtab :global(.form-fields:first-child) {
    flex-grow: 0;
    margin-right: 0.2em;
  }

  .options {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    width: 50%;
    gap: 1rem;
  }

  p.notes {
    margin-top: 0;
  }

  :global(kbd) {
    flex: none;
    padding: 0 4px;
    min-width: 24px;
    background: rgba(255, 255, 255, 0.25);
    border: 1px solid var(--color-border-light-2);
    border-radius: 5px;
    box-shadow: 1px 1px #444;
    text-align: center;
  }
</style>
